/* Farah Lina upgrade layer — additive behaviors.
   No dependencies; every feature degrades gracefully without JS. */
(function () {
  'use strict';
  /* Each FL section emits its own <script src>, so this file can be included
     more than once on a page. Execute the body only the first time. */
  if (window.__flUpgradeInit) return;
  window.__flUpgradeInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on scroll ---------- */
  var toReveal = document.querySelectorAll('.fl-reveal');
  if ('IntersectionObserver' in window && !reduced && toReveal.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    toReveal.forEach(function (el) { io.observe(el); });
  } else {
    toReveal.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- swipe rails: pagination dots ---------- */
  document.querySelectorAll('[data-fl-rail]').forEach(function (wrap) {
    var rail = wrap.querySelector('.fl-rail');
    var dotsBox = wrap.querySelector('.fl-rail-dots');
    if (!rail || !dotsBox) return;
    var items = Array.prototype.slice.call(rail.children);
    if (items.length < 2) { dotsBox.hidden = true; return; }
    items.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to item ' + (i + 1) + ' of ' + items.length);
      b.addEventListener('click', function () {
        rail.scrollTo({ left: items[i].offsetLeft - rail.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      });
      dotsBox.appendChild(b);
    });
    var dots = dotsBox.querySelectorAll('button');
    var sync = function () {
      var x = rail.scrollLeft + rail.clientWidth * 0.25;
      var cur = 0;
      items.forEach(function (it, i) { if (it.offsetLeft - rail.offsetLeft <= x) cur = i; });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
    };
    rail.addEventListener('scroll', sync, { passive: true });
    sync();
    wrap.querySelectorAll('.fl-rail-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = btn.classList.contains('fl-rail-btn--l') ? -1 : 1;
        rail.scrollBy({ left: d * rail.clientWidth * 0.8, behavior: reduced ? 'auto' : 'smooth' });
      });
    });
  });

  /* ---------- photo-card gallery: swipe, arrows, dots, looping ---------- */
  document.querySelectorAll('[data-fl-gal]').forEach(function (wrap) {
    var rail = wrap.querySelector('.fl-rail');
    var dotsBox = wrap.querySelector('.fl-rail-dots');
    if (!rail) return;
    var slides = Array.prototype.slice.call(rail.children);
    if (slides.length < 2) { if (dotsBox) dotsBox.hidden = true; return; }

    function goTo(i) {
      var n = slides.length;
      var t = ((i % n) + n) % n;                 /* wrap both directions */
      rail.scrollTo({ left: slides[t].offsetLeft - rail.offsetLeft,
                      behavior: reduced ? 'auto' : 'smooth' });
    }
    function current() {
      var w = rail.clientWidth || 1;
      return Math.round(rail.scrollLeft / w);
    }

    if (dotsBox) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + slides.length);
        b.addEventListener('click', function (e) { e.preventDefault(); goTo(i); });
        dotsBox.appendChild(b);
      });
    }
    var dots = dotsBox ? dotsBox.querySelectorAll('button') : [];
    function sync() {
      var cur = current();
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', i === cur ? 'true' : 'false');
      }
    }
    rail.addEventListener('scroll', sync, { passive: true });
    sync();

    wrap.querySelectorAll('.fl-rail-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(current() + (btn.classList.contains('fl-rail-btn--l') ? -1 : 1));
      });
    });

    /* a drag must not fire the slide's link */
    var downX = 0, moved = false;
    rail.addEventListener('pointerdown', function (e) { downX = e.clientX; moved = false; });
    rail.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - downX) > 8) moved = true;
    });
    rail.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  });

  /* ---------- quick view bottom sheet ---------- */
  var sheet, scrim, lastFocus;
  function buildSheet() {
    scrim = document.createElement('div');
    scrim.className = 'fl-sheet-scrim';
    sheet = document.createElement('div');
    sheet.className = 'fl-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Quick view');
    document.body.appendChild(scrim);
    document.body.appendChild(sheet);
    scrim.addEventListener('click', closeSheet);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    scrim.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    return format ? format.replace(/\{\{\s*amount\s*\}\}/, v) : '$' + v;
  }
  function openQuickView(handle, trigger) {
    lastFocus = trigger;
    if (!sheet) buildSheet();
    sheet.innerHTML = '<div class="fl-sheet__grab"></div><div class="fl-sheet__body"><p style="grid-column:1/-1;text-align:center;font-style:italic">Loading&hellip;</p></div>';
    sheet.classList.add('is-open');
    scrim.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) { renderSheet(p); })
      .catch(function () {
        sheet.querySelector('.fl-sheet__body').innerHTML =
          '<p style="grid-column:1/-1;text-align:center">Something slipped &mdash; <a class="fl-sheet__link" href="/products/' + handle + '">view the full piece</a></p>';
      });
  }
  function renderSheet(p) {
    var img = p.featured_image ? '<img src="' + p.featured_image + '&width=360" alt="" width="360" height="480">' : '';
    var opts = '';
    if (!(p.variants.length === 1 && p.variants[0].title === 'Default Title')) {
      opts = '<fieldset><legend>' + (p.options[0] && p.options[0].name ? p.options[0].name : 'Size') + '</legend><div class="fl-sheet__opts">' +
        p.variants.map(function (v, i) {
          return '<label><input type="radio" name="fl-variant" value="' + v.id + '"' +
            (v.available ? '' : ' disabled') + (i === 0 && v.available ? ' checked' : '') +
            '><span>' + v.title + '</span></label>';
        }).join('') + '</div></fieldset>';
    }
    sheet.innerHTML =
      '<div class="fl-sheet__grab"></div>' +
      '<button class="fl-sheet__close" aria-label="Close quick view">&times;</button>' +
      '<div class="fl-sheet__body">' + img +
      '<div><h3 class="fl-sheet__title">' + p.title + '</h3>' +
      '<div class="fl-sheet__price">' + money(p.price) + '</div>' + opts +
      '<button class="fl-sheet__atc" type="button">Add to Cart</button>' +
      '<a class="fl-sheet__link" href="' + p.url + '">View full piece</a></div></div>';
    sheet.querySelector('.fl-sheet__close').addEventListener('click', closeSheet);
    var atc = sheet.querySelector('.fl-sheet__atc');
    atc.addEventListener('click', function () {
      var chosen = sheet.querySelector('input[name="fl-variant"]:checked');
      var id = chosen ? chosen.value : (p.variants[0] && p.variants[0].id);
      if (!id) return;
      atc.disabled = true; atc.textContent = 'Adding…';

      /* Ask Shopify to re-render the cart drawer with the add, so we can push
         straight to a checkout button instead of leaving them on the page. */
      var drawer = document.querySelector('cart-drawer');
      var payload = { id: Number(id), quantity: 1 };
      if (drawer && typeof drawer.renderContents === 'function') {
        payload.sections = 'cart-drawer,cart-icon-bubble';
        payload.sections_url = window.location.pathname;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (res) {
          atc.textContent = 'Added \u2713';
          closeSheet();
          if (drawer && res && res.sections) {
            try { drawer.renderContents(res); return; } catch (e) {}
          }
          refreshCartCount();
        })
        .catch(function () { atc.disabled = false; atc.textContent = 'Add to Cart'; });
    });
    var first = sheet.querySelector('input[name="fl-variant"]:checked') || atc;
    first.focus();
  }
  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
      });
      document.dispatchEvent(new CustomEvent('fl:cart-updated', { detail: c }));
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fl-quickview]');
    if (!btn) return;
    e.preventDefault();
    openQuickView(btn.getAttribute('data-fl-quickview'), btn);
  });

  /* ---------- recently viewed (product pages record; section renders) ---------- */
  var KEY = 'fl_recent';
  var meta = document.querySelector('[data-fl-product-handle]');
  if (meta) {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      var h = meta.getAttribute('data-fl-product-handle');
      list = [h].concat(list.filter(function (x) { return x !== h; })).slice(0, 8);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }
  var recentBox = document.querySelector('[data-fl-recent]');
  if (recentBox) {
    var exclude = recentBox.getAttribute('data-fl-recent-exclude');
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    handles = handles.filter(function (x) { return x !== exclude; }).slice(0, 6);
    if (!handles.length) { recentBox.closest('.shopify-section, section') && (recentBox.closest('.shopify-section, section').style.display = 'none'); }
    else {
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; });
      })).then(function (ps) {
        recentBox.innerHTML = ps.filter(Boolean).map(function (p) {
          var im = p.featured_image ? '<img class="fl-img" src="' + p.featured_image + '&width=540" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" width="540" height="720">' : '';
          return '<a class="fl-card" href="' + p.url + '"><div class="fl-card__media">' + im + '</div>' +
            '<div class="fl-card__info"><div class="fl-card__title">' + p.title + '</div>' +
            '<div class="fl-card__price">' + money(p.price) + '</div></div></a>';
        }).join('');
      });
    }
  }

  /* ---------- sticky mobile ATC ---------- */
  var sticky = document.querySelector('.fl-sticky-atc');
  if (sticky) {
    var target = document.querySelector('form[action^="/cart/add"] [name="add"], form[action^="/cart/add"] button[type="submit"]');
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        sticky.classList.toggle('is-on', !es[0].isIntersecting);
      }, { threshold: 0 }).observe(target);
      sticky.querySelector('button').addEventListener('click', function () {
        target.closest('form').requestSubmit ? target.closest('form').requestSubmit(target) : target.click();
      });
    }
  }

  /* ---------- header minimize on scroll ---------- */
  var header = document.querySelector('.fl-header-min') || document.querySelector('sticky-header, .header-wrapper');
  if (header) {
    header.classList.add('fl-header-min');
    var lastY = 0, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y > 240 && y > lastY + 6) header.classList.add('is-hidden');
        else if (y < lastY - 6 || y < 120) header.classList.remove('is-hidden');
        lastY = y; ticking = false;
      });
    }, { passive: true });
  }
})();
